import axios from "axios";


export default axios.create({
    baseURL: process.env.NODE_ENV === "production" ? "https://pilatesonza.com" : "http://192.168.1.144:8001",
});